var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSoundOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sound Off",
    clipPath: "url(#clip0_1075_13174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1075_13174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4375 5.24414C17.4375 3.51847 15.3502 2.65435 14.1308 3.87497L8.31834 9.68747H5.82284C4.34905 9.68747 2.82876 10.5451 2.38701 12.1481C2.08731 13.2401 1.93612 14.3676 1.93751 15.5C1.93751 16.6599 2.0938 17.7836 2.38959 18.8519C2.83005 20.4535 4.35034 21.3125 5.82413 21.3125H8.31705L14.1296 27.125C15.3502 28.3456 17.4375 27.4815 17.4375 25.7558V5.24414ZM22.9658 11.9091C22.8772 11.814 22.7702 11.7376 22.6514 11.6847C22.5325 11.6317 22.4043 11.6033 22.2742 11.601C22.1441 11.5987 22.0149 11.6226 21.8943 11.6713C21.7737 11.72 21.6641 11.7926 21.5721 11.8846C21.4801 11.9765 21.4076 12.0861 21.3589 12.2067C21.3101 12.3274 21.2862 12.4566 21.2885 12.5866C21.2908 12.7167 21.3193 12.845 21.3722 12.9638C21.4252 13.0827 21.5015 13.1896 21.5967 13.2783L23.8183 15.5L21.5967 17.7216C21.4256 17.9053 21.3324 18.1482 21.3368 18.3991C21.3413 18.6501 21.4429 18.8896 21.6204 19.0671C21.7979 19.2446 22.0374 19.3462 22.2883 19.3507C22.5393 19.3551 22.7822 19.2619 22.9658 19.0908L25.1875 16.8691L27.4092 19.0908C27.4979 19.186 27.6048 19.2623 27.7236 19.3153C27.8425 19.3682 27.9708 19.3967 28.1008 19.399C28.2309 19.4013 28.3601 19.3774 28.4807 19.3286C28.6014 19.2799 28.7109 19.2074 28.8029 19.1154C28.8949 19.0234 28.9674 18.9138 29.0162 18.7932C29.0649 18.6726 29.0888 18.5434 29.0865 18.4133C29.0842 18.2832 29.0558 18.1549 29.0028 18.0361C28.9499 17.9173 28.8735 17.8103 28.7783 17.7216L26.5567 15.5L28.7783 13.2783C28.9495 13.0947 29.0426 12.8518 29.0382 12.6008C29.0338 12.3498 28.9321 12.1104 28.7546 11.9329C28.5771 11.7554 28.3377 11.6537 28.0867 11.6493C27.8357 11.6449 27.5928 11.738 27.4092 11.9091L25.1875 14.1308L22.9658 11.9091Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1075_13174",
    x: -2.0625,
    y: -0.696533,
    width: 35.1484,
    height: 32.3931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1075_13174"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1075_13174",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1075_13174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOff);
export default __webpack_public_path__ + "static/media/SoundOff.6b3b825d8069ca68382460616023e32b.svg";
export { ForwardRef as ReactComponent };